import { makeAutoObservable } from 'mobx'
import {
  CREDIT_USAGE_SOURCE_GROUPS,
  type ICreditUsageSourceGroupOption,
} from 'pages/analytics/pages/creditUsage/pages/sources/constants/sourceGroups'

export class SourceGroupFilterStore {
  private _selectedIds: string[] = []
  private _appliedIds: string[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get options(): ICreditUsageSourceGroupOption[] {
    return CREDIT_USAGE_SOURCE_GROUPS
  }

  get isAll() {
    return this._selectedIds.length === 0
  }

  get isAllActive() {
    return this.isAll || this._selectedIds.length === CREDIT_USAGE_SOURCE_GROUPS.length
  }

  get selectedOptions(): ICreditUsageSourceGroupOption[] {
    return this._selectedIds.reduce<ICreditUsageSourceGroupOption[]>((acc, id) => {
      const option = CREDIT_USAGE_SOURCE_GROUPS.find((item) => item.id === id)
      if (option) acc.push(option)
      return acc
    }, [])
  }

  get availableOptions(): ICreditUsageSourceGroupOption[] {
    return CREDIT_USAGE_SOURCE_GROUPS.filter((option) => !this._selectedIds.includes(option.id))
  }

  get isAllApplied() {
    return this._appliedIds.length === 0
  }

  get appliedOptions(): ICreditUsageSourceGroupOption[] {
    return this._appliedIds.reduce<ICreditUsageSourceGroupOption[]>((acc, id) => {
      const option = CREDIT_USAGE_SOURCE_GROUPS.find((item) => item.id === id)
      if (option) acc.push(option)
      return acc
    }, [])
  }

  get selectedSourceGroupKeys(): string[] {
    return this.appliedOptions.flatMap((option) => option.keys)
  }

  isSelected = (id: string) => {
    return this._selectedIds.includes(id)
  }

  select = (id: string) => {
    if (!this._selectedIds.includes(id)) {
      this._selectedIds = [...this._selectedIds, id]
    }
  }

  remove = (id: string) => {
    this._selectedIds = this._selectedIds.filter((selectedId) => selectedId !== id)
  }

  selectAll = () => {
    this._selectedIds = []
  }

  apply = () => {
    const draft = [...this._selectedIds].sort()
    const applied = [...this._appliedIds].sort()
    const isSame =
      draft.length === applied.length && draft.every((id, index) => id === applied[index])

    if (!isSame) {
      this._appliedIds = [...this._selectedIds]
    }
  }
}
